function getSlideIndexFromImageUrl(imageUrl) {
    var slideIndex = -1;
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    
    // Normalize function to compare Shopify image URLs irrespective of size params
    function normalizeUrl(url) {
      if (!url) return '';
      try {
        var base = url.split('?')[0];
        // Remove Shopify size suffixes like _1200x, _x1200, _1200x1200 before the extension
        base = base.replace(/_(\d+x\d+|x\d+|\d+x)(?=\.[a-zA-Z]{2,5}$)/, '');
        return base;
      } catch (e) {
        return url;
      }
    }
    
    var normalizedTarget = normalizeUrl(imageUrl);
    
    if (isMobile) {
      // Mobile: use mobile gallery
      var $scope = $('.custom-swipix-container-pdp-img--mobile');
      var $imgs = $scope.find('img');
      if ($imgs.length === 0) {
        $imgs = $('.dev_show_images_after_slick_load img');
      }
      
      $imgs.each(function(index) {
        var srcAttr = $(this).attr('src');
        var dataSrcAttr = $(this).attr('data-src');
        var normalizedSrc = normalizeUrl(srcAttr);
        var normalizedDataSrc = normalizeUrl(dataSrcAttr);
        if (normalizedTarget && (normalizedTarget === normalizedSrc || normalizedTarget === normalizedDataSrc)) {
          slideIndex = index;
          return false;
        }
      });
      
      if (slideIndex !== -1) {
        newPDPimgSwipix.slideTo(parseInt(slideIndex));
      }
    } else {
      // Desktop: try desktop gallery first, then fallback to mobile gallery
      var $desktopScope = $('.custom-swipix-container-pdp-img--desktop');
      var $desktopImgs = $desktopScope.find('img');
      
      // First try to find in desktop gallery
      $desktopImgs.each(function(index) {
        var srcAttr = $(this).attr('src');
        var dataSrcAttr = $(this).attr('data-src');
        var normalizedSrc = normalizeUrl(srcAttr);
        var normalizedDataSrc = normalizeUrl(dataSrcAttr);
        if (normalizedTarget && (normalizedTarget === normalizedSrc || normalizedTarget === normalizedDataSrc)) {
          slideIndex = index;
          return false;
        }
      });
      
      // If not found in desktop gallery, try mobile gallery (for variant images)
      if (slideIndex === -1) {
        var $mobileScope = $('.custom-swipix-container-pdp-img--mobile');
        var $mobileImgs = $mobileScope.find('img');
        
        $mobileImgs.each(function(index) {
          var srcAttr = $(this).attr('src');
          var dataSrcAttr = $(this).attr('data-src');
          var normalizedSrc = normalizeUrl(srcAttr);
          var normalizedDataSrc = normalizeUrl(dataSrcAttr);
          if (normalizedTarget && (normalizedTarget === normalizedSrc || normalizedTarget === normalizedDataSrc)) {
            slideIndex = index;
            return false;
          }
        });
      }
      
      // If still not found, fallback to first slide
      if (slideIndex === -1) {
        slideIndex = 0;
      }
      
      if (window.newPDPimgSwipixDesktop) {
        newPDPimgSwipixDesktop.slideTo(parseInt(slideIndex));
      } else {
        newPDPimgSwipix.slideTo(parseInt(slideIndex));
      }
    }
  }
  
  // EDD event tracking function
  function eddeventcall(eddparam, pincode) {
    // Use requestAnimationFrame to defer non-critical operations
    requestAnimationFrame(() => {
      gaEvent('EDD',[pincode, eddparam, '', '', '', ''], false);
    });
  }
  
  // Helper functions - moved outside of event handlers for better performance
  function getOrdinalSuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    const lastDigit = day % 10;
    switch (lastDigit) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }
  
  function getDayAndMonth(dateString) {
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    return `${day}${getOrdinalSuffix(day)} ${month}`;
  }
  
  function getDateFromTimestamp(timestamp) {
    const date = new Date(timestamp);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }
  
  function formatDate(inputDate) {
    const [year, month, day] = inputDate.split("-").map(Number);
    const date = new Date(year, month - 1, day);
    const dayFormatted = date.getDate().toString().padStart(2, "0");
    const monthFormatted = new Intl.DateTimeFormat("en-GB", {
      month: "short",
    }).format(date);
    return `${dayFormatted}-${monthFormatted}`;
  }
  
  // Wait for DOM to be fully loaded before attaching events
  document.addEventListener('DOMContentLoaded', function() {
    // Initialize image number in localStorage - done once
    if (!localStorage.getItem('pdp_image_number')) {
      localStorage.setItem('pdp_image_number', JSON.stringify([]));
    }
  
    // Use event delegation for all document events
    document.addEventListener('click', function(event) {
      const target = event.target;
      
      // View all button click
      if (target.closest('.dev_pdp_view_all_btn_click')) {
        document.querySelector('#first-modal').style.display = 'block';
        return;
      }
      
      // Re-enter pincode click
      if (target.closest('.dev_reenter_pincode')) {
        document.querySelector(".dev_edd_content").style.display = 'none';
        document.querySelector(".npdp-pincode-parent").style.display = 'flex';
        return;
      }
      
      // Check pincode click
      if (target.closest('.dev_npdp_checkpincode')) {
        handlePincodeCheck(event);
        return;
      }
      
      // FAQ arrow click
      // if (target.closest('.dev_arrow')) {
      //   const arrowElem = target.closest('.dev_arrow');
      //   const answerElem = arrowElem.closest(".faq-start").querySelector(".faq-answer");
      //   // Use classList.toggle for better performance than jQuery toggle
      //   answerElem.style.display = answerElem.style.display === 'none' ? 'block' : 'none';
      //   arrowElem.classList.toggle("arrow-down");
      //   return;
      // }
      
      // Wishlist button click
      if (target.closest('.dev_e_wishlist')) {
        if (typeof dataLayer !== 'undefined') {
          requestAnimationFrame(() => {
            gaEvent('wishlist_button',["pdp_img", '', '', '', '', ''], false);
          });
        }
        return;
      }
      
      // ATC top button click
      if (target.closest('.dev_e_atc_top')) {
        const bottomButton = document.querySelector('.dev_e_atc_bottom');
        if (bottomButton && 
            isElementVisible(bottomButton)) {
          if (typeof dataLayer !== 'undefined') {
            requestAnimationFrame(() => {
              gaEvent('atc_top',["", '', '', '', '', ''], false);
            });
          }
        }
        return;
      }
      
      // ATC bottom button click
      if (target.closest('.dev_e_atc_bottom')) {
        if (typeof dataLayer !== 'undefined') {
          requestAnimationFrame(() => {
            gaEvent('atc_bottom',["", '', '', '', '', ''], false);
          });
        }
        return;
      }
      
      // Show notify click
      if (target.closest('.dev_click_show_notify')) {
        document.querySelector('#mynotifyacbcusmodal').style.display = 'block';
        return;
      }
    });
  
    // Initialize Swipix components with proper debouncing
    initSwipixSliders();
  });
  
  // Check if an element is visible
  function isElementVisible(element) {
    return element.offsetWidth > 0 && element.offsetHeight > 0 && 
           window.getComputedStyle(element).visibility !== 'hidden';
  }
  
  // Handle pincode check - extracted to improve readability and maintainability
  function handlePincodeCheck(event) {
    const pincodeInput = document.querySelector(".dev_pincode");
    const pincodeError = document.querySelector('.dev_pincode_error');
    const eddContent = document.querySelector(".dev_edd_content");
    const pincodeParent = document.querySelector(".npdp-pincode-parent");
    const diwaliText = document.querySelector('.dev_edd_diwali_text');
    const onlyEdd = document.querySelector('.dev_only_edd');
    
    if (diwaliText) diwaliText.style.display = 'none';
    if (onlyEdd) onlyEdd.style.display = 'none';
    
    // Validate pincode
    if (pincodeInput.value.length !== 6) {
      if (pincodeError) pincodeError.innerHTML = "Invalid pincode";
      return;
    }
    
    if (pincodeError) pincodeError.innerHTML = "";
    
    // Track GA4 event for pincode check
    // if (event.isTrusted && typeof dataLayer !== 'undefined') {
    //   const gaUserId = localStorage.getItem('ga-user-id') || undefined;
    //   requestAnimationFrame(() => {
    //     dataLayer.push({ custom: null });
    //     dataLayer.push({
    //       event: "atc_pincode",
    //       custom: {
    //         param_1: pincodeInput.value,
    //         param_2: "",
    //         param_3: "",
    //         param_4: "",
    //         tsc_user_id: gaUserId
    //       }
    //     });
    //   });
    // }
    
    // Hide pincode input
    if (pincodeParent) pincodeParent.style.display = 'none';
    
    // Prepare EDD API call
    const eddData = {
      dropPincode: pincodeInput.value,
      productId: document.querySelector('.dev_edd_product_id')?.value,
      variantId: document.querySelector('.dev_edd_variant_id')?.value,
      productsku: document.querySelector('.dev_edd_product_sku')?.value
    };
    
    // Call EDD API
    const expressEDDHrs = 48;
    fetchEDDData(eddData, expressEDDHrs);
    
    // Call installation API
    fetchInstallationData(pincodeInput.value);
    
    // Update pincode in localStorage
    const popupPincode = localStorage.getItem('popupPincode');
    if (popupPincode && pincodeInput.value && popupPincode != pincodeInput.value) {
      localStorage.setItem('longitude', '');
      localStorage.setItem('latitude', '');
      localStorage.setItem('popupPincode', pincodeInput.value);
    } else if (pincodeInput.value) {
      localStorage.setItem('popupPincode', pincodeInput.value);
    }
    
    // Show EDD content
    if (eddContent) eddContent.style.display = 'flex';
    if(event.isTrusted){
      gaEvent('atc_pincode', [pincodeInput.value, '', '', '', '', ''], true);
    }
  }
  
  // Fetch EDD data - separate network call
  function fetchEDDData(eddData, expressEDDHrs) {
    const eddTextElement = document.querySelector(".dev_edd_text");
    const eddIconImg = document.querySelector("#edd_icon_img");
    const eddIcon = document.querySelector(".edd_icon svg");
    const onlyEdd = document.querySelector('.dev_only_edd');
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    const raw = JSON.stringify({
      "data": [
        {
          "SKU": eddData.productsku,
          "product_id": eddData.productId,
          "drop_pincode": eddData.dropPincode,
          "variant_ids": [eddData.variantId]
        }
      ]
    });
    
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    
    // Use Promise.race to add a timeout to the fetch
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Request timed out')), 5000)
    );
    
    Promise.race([
      fetch("https://apis.thesleepcompany.in/edd/edd/get-edd", requestOptions),
      timeoutPromise
    ])
      .then(response => response.json())
      .then(result => {
        if (result.data && result.data.length > 0) {
          let isExpressEDD = false;
          let minEddClickpost, maxEddClickpost;
          
          result.data.forEach(product => {
            product.response.data.forEach(variant => {
              if (variant.isXpressDelivery) {
                isExpressEDD = true;
              }
              minEddClickpost = getDayAndMonth(variant.newMinDate);
              maxEddClickpost = getDayAndMonth(variant.newMaxDate);
            });
          });
          
          if (isExpressEDD) {
            eddTextElement.innerHTML = `<span style="text-align:center;color:#1a2b58;"><span style="font-family:'Montserrat-Bold';">Express Delivery</span> within <span style="font-family:'Montserrat-Bold';"> ${expressEDDHrs} hours</span></span>`;
            eddIconImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Group_1410128203.svg?v=1735644948");
          } else {
            eddTextElement.innerHTML = '<span style="text-align: center;">Estimated Delivery Date ' + minEddClickpost + ' to ' + maxEddClickpost + '</span>';
            eddIconImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Estimate_icon_edaa282e-b643-42d8-bc5a-64487649bd98.svg?v=1735634654");
          }
          
          eddIconImg.style.display = 'block';
          if (eddIcon) eddIcon.style.display = 'none';
          
          // Send tracking event
          eddeventcall(minEddClickpost + " to " + maxEddClickpost, eddData.dropPincode);
          
          if (onlyEdd) onlyEdd.style.display = 'flex';
          localStorage.setItem('isNearerStore', 'true');
        } else {
          showDefaultEDDMessage(eddTextElement, eddIconImg, eddIcon, onlyEdd);
          localStorage.setItem('isNearerStore', 'false');
        }
      })
      .catch(error => {
        console.error("EDD API Error:", error);
        showDefaultEDDMessage(eddTextElement, eddIconImg, eddIcon, onlyEdd);
      });
  }
  
  // Show default EDD message when API fails
  function showDefaultEDDMessage(eddTextElement, eddIconImg, eddIcon, onlyEdd) {
    const dateNow = new Date();
    const minDate = getDateFromTimestamp(dateNow.setDate(dateNow.getDate() + 5));
    const dateForMax = new Date();
    const maxDate = getDateFromTimestamp(dateForMax.setDate(dateForMax.getDate() + 8));
    const formatMinDate = getDayAndMonth(minDate);
    const formatMaxDate = getDayAndMonth(maxDate);
    
    eddTextElement.innerHTML = '<span style="text-align: center;">Estimated Delivery Date ' + formatMinDate + ' to ' + formatMaxDate + '</span>';
    eddIconImg.setAttribute("src", "https://cdn.shopify.com/s/files/1/0635/6929/7637/files/Estimate_icon_edaa282e-b643-42d8-bc5a-64487649bd98.svg?v=1735634654");
    eddIconImg.style.display = 'block';
    if (eddIcon) eddIcon.style.display = 'none';
    if (onlyEdd) onlyEdd.style.display = 'block';
  }
  
  // Fetch installation data - separate network call
  function fetchInstallationData(pincode) {
    const installationText = document.querySelector(".dev_installation_text");
    if (!installationText) return;
    
    const headers = new Headers();
    headers.append("x-api-key", "KPwkS7MFb71KXrezuxUYJaf4EnFGvgkK9kgWaf7q");
    
    const requestOptions = {
      method: "GET",
      headers: headers,
    };
    
    // Use Promise.race to add a timeout to the fetch
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('Request timed out')), 5000)
    );
    
    Promise.race([
      fetch(`https://api.thesleepcompany.in/product-installation/${pincode}`, requestOptions),
      timeoutPromise
    ])
      .then(response => response.text())
      .then(result => {
        try {
          const resObj = JSON.parse(result);
          if (resObj.data && resObj.data.length > 0) {
            const tat = parseInt(resObj.data[0]["tat"]);
            if (tat > 0) {
              let tatText = "";
              if(tat == 2){
                tatText = '48 hours';
              }else{
                tatText = `${tat} to ${tat + 3} days`;
              }
              installationText.textContent = `Free Installation within ${tatText} after delivery.`;
            } else {
              installationText.textContent = `Installation service not available. Use Coupon DIYINSTALL on CHECKOUT to get INR 500 discount.`;
              localStorage.setItem('isNearerStore', 'false');
            }
          } else {
            installationText.textContent = `Installation service not available. Use Coupon DIYINSTALL on CHECKOUT to get INR 500 discount.`;
            localStorage.setItem('isNearerStore', 'false');
          }
        } catch (e) {
          console.error("Error parsing installation data:", e);
          installationText.textContent = `Installation service not available. Use Coupon DIYINSTALL on CHECKOUT to get INR 500 discount.`;
          localStorage.setItem('isNearerStore', 'false');
        }
      })
      .catch(error => {
        console.error("Installation API Error:", error);
        installationText.textContent = `Installation service not available. Use Coupon DIYINSTALL on CHECKOUT to get INR 500 discount.`;
        localStorage.setItem('isNearerStore', 'false');
      });
  }
  
  // Initialize Swipix sliders with proper performance handling
  function initSwipixSliders() {
    // Use requestIdleCallback or setTimeout as a fallback to defer non-critical initialization
    const initSliders = () => {
      // Features slider
      if (document.querySelector('#aaaaaa')) {
        new Swipix({
          container: '#aaaaaa',
          nextButton: '.rigth-arrow-feature-arrow',
          prevButton: '.left-arrow-feature-arrow',
          slidesPerView: {
            default: 1.3,
            768: 2,
            1024: 2.5
          },
          lazyMedia: true,
          lazyPix: true,
          gap: 20,
          infiniteLoop: true,
          autoplay: {
            enabled: true,
            delay: 5000,               
            pauseOnInteraction: false,  
            pauseAfterInteraction: false 
          },
          tabsConfig: {
            container: '.npdp_features_menu',
            buttonSelector: '.npdp_features_menu_title',
            mapping: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
            activeClass: 'active'
          }
        }).init();
      }
  
      // Specification slider
      if (document.querySelector('.npdp_specification_details')) {
        new Swipix({
          container: '.npdp_specification_details',
          nextButton: '.rigth-arrow-spcs-arrow',
          prevButton: '.left-arrow-spcs-arrow',
          slidesPerView: {
            default: 1,
          },
          lazyPix: true,
          dynamicHeight: true,
          tabsConfig: {
            container: '.npdp_specification_menu',
            buttonSelector: '.npdp_specification_menu_title',
            mapping: [0, 1, 2, 3, 4],
            activeClass: 'active'
          }
        }).init();
      }
  
      // Chairs PDP card slider
      if (document.querySelector('.recom-prod-slider')) {
        new Swipix({
          container: '.recom-prod-slider',
          nextButton: '.right-arrow-recom-arrow',
          prevButton: '.left-arrow-recom-arrow',
          lazyPix: true,
          infiniteLoop: true,
          slidesPerView: {
            default: 1.2,
            768: 1.3,
            1024: 2.8
          },
          gap: 10,
        }).init();
      }
    };
  
    // Use requestIdleCallback if available, or setTimeout as fallback
    if (window.requestIdleCallback) {
      window.requestIdleCallback(initSliders);
    } else {
      setTimeout(initSliders, 200);
    }
  }
  
  
  ////// DO NOT /////////
  addEventListener("DOMContentLoaded", (e) => {
    $(document).on("click", ".npdp_menu_title", function (event) {
      event.preventDefault();
    
      var hash = this.getAttribute("href");
      var targetElement = document.querySelector(hash);
      var headerHeight = document.querySelector("sticky-header")?.getBoundingClientRect().height || 0;
      
      if (hash !== "#pdp_images") {
          headerHeight += document.querySelector(".menu-80div")?.getBoundingClientRect().height || 0;
      }
    
      if (targetElement) {
          var scrollTo = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
    
          // Force correct scrolling in Safari
          requestAnimationFrame(() => {
              window.scrollTo({ top: scrollTo, behavior: "smooth" });
          });
    
          // Precise correction for iPhone overscroll
          setTimeout(() => {
              var actualScroll = window.scrollY;
              if (Math.abs(actualScroll - scrollTo) > 3) { // If overscrolled, adjust
                  window.scrollTo({ top: scrollTo, behavior: "instant" });
              }
          }, 1200); // Ensure correction after smooth scroll completes
      }
    });
  
    document.addEventListener("scroll", () => {
      const h3Tags = document.querySelectorAll(".dev_observer_active");
  
      // Function to update active classes based on scroll position
      const updateActiveClass = () => {
          const offsetThreshold = 200; // Distance in pixels from the top of the viewport
  
          h3Tags.forEach(tag => {
              const rect = tag.getBoundingClientRect();
              const tagDistanceFromTop = rect.top;
  
              if (tagDistanceFromTop <= offsetThreshold && tagDistanceFromTop >= 0) {
                  // Remove active class from elements whose parent has the class npdp_menu
                  document.querySelectorAll('.npdp_menu .active').forEach(el => {
                      el.classList.remove('active');
                  });
  
                  // Add active class to the intersecting elements
                  document.querySelectorAll(`.${tag.id}`).forEach(el => {
                      el.classList.add('active');
                  });
              }
          });
      };
      // Debounce the function to avoid excessive calls
      setTimeout(updateActiveClass, 300);
    });
  
  });
  
  $(document).on("click", ".dev_arrow", function () {
    $(this).parents(".faq-start").find(".faq-answer").slideToggle();
    $(this).toggleClass("arrow-down");
  });
  
  $(document).on("click", "#locate_str_btn", function () {
    document.querySelector('.store-locator-container').style.display = 'flex';
  });
  
  $(document).on('click', '.bfpmp-popin-popup', function () {
    gaEvent('video_call_popin',["PDP Bottom Floater", "", '', '', '', ''], false);
  });
  
  $(document).on('click', '.bfpmp-store-nearme', function () {
    var parentHref = $(this).find('a').attr('href');
    gaEvent('store_visit',["PDP Bottom Floater", parentHref, '', '', '', ''], false);
  });
  
  $(document).on('click', '.chair-pdp-atc-sticky #add-to-cart-button', function () {
    gaEvent('TSC_atc',["PDP Bottom Floater", "", '', '', '', ''], true);
  });
  
  $(document).on('click', '.form-sheet-submit-btn', function () {
    const newsLetterInputs = document.querySelectorAll('.newsletter-form__field-wrapper .footer-newsletter-input');
    const pincode = newsLetterInputs[0].value.trim();
    const phone = newsLetterInputs[1].value.trim();
    const errorMsg = document.querySelector('.error-message-text');
  
    const isValidPincode = /^\d{6}$/.test(pincode);
    const isValidPhone = /^\d{10}$/.test(phone);
  
    if (!isValidPincode) {
      errorMsg.innerHTML = 'Please enter a valid 6-digit pincode.';
      return; // Stop further execution
    }
  
    if (!isValidPhone) {
      errorMsg.innerHTML = 'Please enter a valid 10-digit phone number.';
      return; // Stop further execution
    }
  
    fetch("https://apis.thesleepcompany.in/lead/datafeed", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
          pincode: pincode,
          phone: phone,
          source: "Newsletter Community",
          lead_status: "Tier 1",
          activity_source: "Newsletter Community",
          activity_note: pincode,
          mx_mobile_device: getDeviceModel(),
          mx_mobile_os: getOSWithVersion(),
          is_web_engage_event: true,
          web_engage_data: {
              pincode: pincode,
              phone: phone,
          },
      }),
    })
  
   // gaEvent('send_my_discount_code', ['send_my_discount_code', '333',pincode,`+91${phone}`,'',''], false);
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    // document.querySelectorAll('.pdp-dynamic-ofer-header > a').forEach(function(button) {
    //   button.addEventListener('click', function(e) {
    //     //e.preventDefault();
    //     //document.getElementById('first-modal').classList.add('show-model');
    //     gaEvent('view_more_offers', ['abc','','','','',''], false);
    //   });
    // })
  
    document.querySelectorAll('#close-bank-offer-pop-up').forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        document.getElementById('first-modal').classList.remove('show-model');
      });
    })
  })
  
  // Redirect for Aura brown color
    if (window.location.href === 'https://thesleepcompany.in/products/aura-executive-chair') {
    window.location.href = 'https://thesleepcompany.in/products/aura-executive-chair?variant=46753362608357';
  }